import { render, staticRenderFns } from "./manufacturerForm.vue?vue&type=template&id=09cd0f20&scoped=true&"
import script from "./manufacturerForm.vue?vue&type=script&lang=js&"
export * from "./manufacturerForm.vue?vue&type=script&lang=js&"
import style0 from "./manufacturerForm.vue?vue&type=style&index=0&id=09cd0f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cd0f20",
  null
  
)

export default component.exports